const { default: axiosIns } = require('@/libs/axios')

const UploadService = {
  // POST - UploadApiController
  async uploadImage(file, accountId, validateImage = false) {
    return axiosIns
      .post(`/upload/image?accountId=${accountId}&validateImage=${validateImage}`, file, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      })
      .then(response => response.data)
  },
}

export default UploadService
